module.exports = __webpack_public_path__ + "img/FooterMoyudan.f87db54d.png";